import * as z from 'zod'

export const fieldOfLawSchema = z.object({
  name: z
    .string({ required_error: 'Bitte geben Sie einen Namen für das Rechtsgebiet an.' })
    .trim()
    .min(1, 'Bitte geben Sie einen Namen für das Rechtsgebiet an.'),
  id: z.string(),
})
